import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { SidebarComponent } from '../sidebar/sidebar.component';
import { FooterComponent } from '../footer/footer.component';

@Component({
    selector: 'app-default-layout',
    standalone: true,
    imports: [RouterOutlet, SidebarComponent, FooterComponent],
    templateUrl: './default-layout.component.html',
    styleUrl: './default-layout.component.css'
})
export class DefaultLayoutComponent {

}
